import React, { useState } from "react";
import CancelOutlined from "@material-ui/icons/CancelOutlined";

type AlertProps = {
    attentionText: string;
    text: string;
    onClickClose: Function;
    timerLengthInMS?: number;
    danger?: boolean;
    dangerText?: string;
    dangerAttentionText?: string;
};

export const SuccessAlert = ({ ...props }: AlertProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(true);
    const onClickClose = () => {
        setIsOpen(false);
        if (props.onClickClose) {
            props.onClickClose();
        }
    };

    if (props.timerLengthInMS) {
        new Promise(() => {
            setTimeout(onClickClose, props.timerLengthInMS);
        });
    }
    return (
        <>
            { isOpen &&
                <div className={"alert-card " + (props.danger ? "danger" : "success")}>
                    <div>
                        {!props.danger ?
                            <div>
                                <b>{props.attentionText}</b> {props.text}
                            </div> :
                            <div>
                                <b>{props.dangerAttentionText}</b> {props.dangerText}
                            </div>
                        }
                    </div>
                    <CancelOutlined onClick={onClickClose} />
                </div> }
        </>
    );
};
